<!--
Copyright 2021 The Ground Authors.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
-->

<div class="job-list-item-container">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <!-- Tree node for lois -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [class.tree-node-selected]="isSelectedLoi(node)"
      class="loi-tree-node" role="button" tabindex="0" mat-button (click)="selectLoi(node)"
      [style.padding-left]="isSidePanelExpanded() ? '40px' : '16px'">
      <mat-icon svgIcon="{{ node.iconName }}" class="{{ node.jobId }} loi-icon" [ngStyle]="{color: node.iconColor}"
        [style.padding-left]="isSidePanelExpanded() ? '10px' : '0'"></mat-icon>
      <div class="loi-name" *ngIf="isSidePanelExpanded()">
        {{ node.name }}
      </div>
    </mat-tree-node>
    <!-- Tree node for jobs -->
    <mat-tree-node
      [class.tree-node-selected]="isSelectedLoi(node)"
      *matTreeNodeDef="let node; when: hasChild"
      matTreeNodePadding class="expandable-node"
    >
      <div class="expandable-node-start" *ngIf="isSidePanelExpanded()">
        <button mat-icon-button [attr.aria-label]="'Toggle ' + node.item" matTreeNodeToggle>
          <mat-icon class="mat-icon-rtl-mirror">
            chevron_right
          </mat-icon>
        </button>

        <mat-icon class="job-icon" [ngStyle]="{color: node.iconColor}">
          {{ node.iconName }}
        </mat-icon>

        <div class="job-name">{{ node.name }}</div>
      </div>

      <div class="expandable-node-start" *ngIf="!isSidePanelExpanded()">
        <button mat-icon-button [attr.aria-label]="'Toggle ' + node.item" matTreeNodeToggle>
          <mat-icon class="job-icon" [ngStyle]="{color: node.iconColor}"
            (click)="treeControl.toggle(node)">
            {{ node.iconName }}
          </mat-icon>
        </button>
      </div>

      <div [ngSwitch]="actionsType" *ngIf="isSidePanelExpanded()">
        <div *ngSwitchCase="jobListItemActionsType.MENU">
          <button mat-icon-button [matMenuTriggerFor]="jobMenu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #jobMenu="matMenu">
            <a (click)="onDownloadCsvClick()" target="_blank">
              <button mat-menu-item>
                <span>Download job data</span>
              </button>
            </a>
          </mat-menu>
        </div>
        <div *ngSwitchCase="jobListItemActionsType.BACK">
          <button mat-icon-button aria-label="back" (click)="onGoBackClick()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </mat-tree-node>
  </mat-tree>
</div>
